import { AmplifyAPI } from 'src/app/models/amplifyApi';
import { CONFIG } from '../../../environments/environment';

export function AmplifyServiceBuilder(api_name: string, headers?: boolean, body?: any, queryStringParameters?: any) {
  const api: AmplifyAPI = CONFIG.API.endpoints.find((obj) => obj.name === api_name);
  const requestData = {
    headers: null,
    body: null,
    queryStringParameters: null
  };
  if (headers) {
    requestData.headers = { 'x-api-key': api.apiKey };
  }
  if (body) {
    requestData.body = body;
  }
  if (queryStringParameters) {
    requestData.queryStringParameters = queryStringParameters;
  }

  return requestData;
}
